import { render, staticRenderFns } from "./AlertA2P.vue?vue&type=template&id=ab46623c&scoped=true&"
import script from "./AlertA2P.vue?vue&type=script&lang=js&"
export * from "./AlertA2P.vue?vue&type=script&lang=js&"
import style0 from "./AlertA2P.vue?vue&type=style&index=0&id=ab46623c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab46623c",
  null
  
)

export default component.exports